"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.commonSaverLibrary = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _sweetalert = require("sweetalert");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _ajaxHelper = require("../libraries/ajaxHelper");

var _ajaxHelper2 = _interopRequireDefault(_ajaxHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var commonSaverLibrary = exports.commonSaverLibrary = {
    saveCommon: function saveCommon(event, onSaveEvent, saveParams) {
        var saveButton = event.target.tagName !== 'BUTTON' && event.target.parentElement.tagName === 'BUTTON' ? event.target.parentElement : event.target;
        // save params can be assigned by 2 options: Html dataset params or from javascript as js object
        saveParams = _extends({}, saveButton.dataset || {}, saveParams || {});

        var inputSelector = saveParams.commonSaveInputSelector || '.common-save-input';
        var savingObject = {};
        var _saveParams = saveParams,
            commonSaveUrl = _saveParams.commonSaveUrl,
            commonSaveValidate = _saveParams.commonSaveValidate;

        var inputList = document.querySelectorAll(inputSelector);

        if (inputList.length === 0) {
            console.warn("No input items found by selector " + inputSelector);
            return;
        }
        if (!commonSaveUrl) {
            console.warn("No URL defined for saving. Please define it by parameter: data-common-save-url (dataset.commonSaveUrl) of saving button.");
            return;
        }

        var isValid = true;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = inputList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var input = _step.value;

                // multiple options how to name parameter, which will be inserted into request body
                var paramName = input.dataset.commonSaveParamName || input.dataset.commonSaveParameterName || input.id || input.name;
                if (!paramName || input.type === 'button' || input.type === 'submit' || savingObject[paramName]) continue;

                var valueProperty = input.dataset.commonSaveValueProperty;
                var value = commonSaverLibrary.resolveValue(valueProperty, input);
                if (value === undefined) return;

                // all fields must be valid
                if (commonSaveValidate && commonSaveValidate !== 'false') isValid &= commonSaverLibrary.processValidation(input);

                // if saving property is member of (js) object
                var name = input.name || input.dataset.commonSaveName || '';
                if (!!name && input.classList.contains('common-save-as-object') && name.indexOf('.') > 0 && name.length >= 3) {
                    var objName = name.substring(0, name.indexOf('.'));
                    var objParamName = name.substring(name.indexOf('.') + 1);
                    var newParamObject = _defineProperty({}, objParamName, value);
                    savingObject[objName] = _extends({}, savingObject[objName], newParamObject);
                } else {
                    savingObject[paramName] = value;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        if (!isValid) {
            (0, _sweetalert2.default)({
                text: Resx.Validation.RegistrationValidationFailedBody,
                title: Resx.Validation.RegistrationValidationFailedTitle,
                icon: 'warning'
            });
            return;
        }

        var entityId = saveParams.commonSaveId;
        if (entityId) savingObject.Id = entityId;

        var ajaxHelper = new _ajaxHelper2.default();
        ajaxHelper.sendRequest(commonSaveUrl, function (httpRequest, rspObj) {
            if (typeof onSaveEvent === 'function') onSaveEvent(httpRequest, rspObj, saveParams);else commonSaverLibrary.saveDone(httpRequest, rspObj, saveParams);
        }, savingObject);
    },

    saveDone: function saveDone(httpRequest, responseObject, saveParams) {
        if (!responseObject || !responseObject.success || !responseObject.result) {
            (0, _sweetalert2.default)({ text: Resx.Common.Error, title: Resx.Common.AjaxError, icon: 'error' });
            console.error('Error saving data by CommonSaver.', httpRequest, responseObject);
            return;
        }

        var success = responseObject.result.success;

        var message = responseObject.result.message;
        var swIcon = success ? 'success' : 'warning';

        (0, _sweetalert2.default)({ text: message, title: message, icon: swIcon }, function () {
            var afterSaveUrl = responseObject.result.redirectUrl || (saveParams || {}).commonSaveAfterSaveUrl;

            if (afterSaveUrl && success) {
                window.location.href = afterSaveUrl;
            }
        });
        if (!success) {
            console.warn(responseObject.detail);
        }
    },

    resolveValue: function resolveValue(valueProperty, input) {
        var value = void 0;
        try {
            value = valueProperty ? input[valueProperty] : input.value;
            // test only null or undefined, because 0 or '' is valid value
            if (value === null || value === undefined) {
                // last try :)
                value = input.textContent;
            }

            if (input.type === 'checkbox') {
                value = !!input.checked;
            } else if (value.match(/^[0-9]+$/) && !input.classList.contains('common-save-text')) {
                value = parseInt(value);
            } else if (value.match(/^[0-9]+[.,]?[0-9]*$/) && !input.classList.contains('common-save-text')) {
                value = parseFloat(value.replace(',', '.'));
            } else if (value.toLowerCase() === 'true') {
                return true;
            } else if (value.toLowerCase() === 'false') {
                return false;
            }
        } catch (e) {
            console.error('Error in method resolveValue.', input, e);
        }

        return value;
    },

    processValidation: function processValidation(input) {
        // MVC (jQuery) validation - custom execution
        if (!input.classList.contains('no-client-validation') && input.dataset.noClinetValidation !== 'true') {
            // custom validation omitting jQuery validation enforces invalidity for whole form (saving object)
            if (input.dataset.isInvalid === 'true') return false;

            try {
                // in some cases jQuery validation causes error   
                $.validator.unobtrusive.parse(input);
                $(input).validate();
                // dataset - isInvalid - custom validation, jQuery - is defined in Dto model - validation attribute
                if (!$(input).valid()) {
                    return false;
                }
            } catch (e) {
                console.error('Error in jQuery validation. Input and exception follows.', input, e);
            }
        }
        return true;
    }
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/libraries/commonSaverLibrary.js
// module id = 253
// module chunks = 0